// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconRoute2, IconBasket, IconHomeDown, IconTruckDelivery, IconMessages, IconAward } from '@tabler/icons';

// type
import { NavItemType } from 'types';
import MessagesTitle from './messages';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconRoute2,
    IconBasket,
    IconHomeDown,
    IconTruckDelivery,
    IconMessages,
    IconAward
};
const partnerManagement: NavItemType = {
    id: 'partner-management',
    title: <FormattedMessage id="Partner Management" />,
    type: 'group',
    children: [
            {
                id: 'donor',
                title: <FormattedMessage id="Donor" />,
                icon: icons.IconBasket,
                type: 'item',
                url: '/donors',
                target: false
            },
            {
                id: 'recipient',
                title: <FormattedMessage id="Recipient" />,
                icon: icons.IconHomeDown,
                type: 'item',
                url: '/recipients',
                target: false
            },
            {
                id: 'delivery-driver',
                title: <FormattedMessage id="Delivery Driver" />,
                icon: icons.IconTruckDelivery,
                type: 'item',
                url: '/delivery-drivers',
                target: false
            },
            {
                id: 'messages',
                title: <MessagesTitle />,
                type: 'item',
                icon: icons.IconMessages,
                url: '/messages',
                target: false
            },
    ]
};

export default partnerManagement;
